import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class LineHeightMultiplier extends BaseOption {
  static userInterfaceComponent = {
    label: "Line Height Multiplier",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      step: "any",
      placeholder: "Auto",
    },
  };

  static defaultValue = "normal";

  static convertConfigValueToCompiledValue(configValue) {
    if (!configValue) {
      return 0;
    }

    return configValue;
  }
}
